/**
 * Created : vincent
 * Date : 2018/5/11  4:48 PM
 * Email : wangxiao@wafersystems.com
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';

class Top5List extends React.Component {
  render() {
    const { value, label, data, locals } = this.props;
    return (
      <div className="top5_list">
        {data.map((v, i) => {
          if (i < 5) {
            return (
              <div key={i} className={i % 2 === 0 ? 'item' : 'item2'}>
                <div className="label" title={v[label]}>
                  {i + 1}.{' '}
                  {v[label].length > 14
                    ? v[label].slice(0, 10) + '...'
                    : v[label]}
                </div>
                <div className="value">
                  {v[value]}
                  {locals === 'en_US' ? (
                    ''
                  ) : (
                    <FormattedMessage id="fault_times" />
                  )}
                </div>
              </div>
            );
          }
        })}
      </div>
    );
  }
}

export default Top5List;



// WEBPACK FOOTER //
// ./src/components/monitor/Top5List.js